import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.afterpay = {
      variant: 'flex.row.start.center',

      text: {
        color: 'mediumDarkGray',
        fontSize: [3, 4],
        mb: 0,
      },

      link: {
        ml: 2,
      },

      pill: {
        width: ['56px', '62px'],
        marginTop: '2px',
        borderRadius: '10px',
        bg: '#FFFFFF',
        position: 'relative',
        overflow: 'hidden',
      },

      logo: {
        width: ['56px', '62px'],
      },
    };
  })()
);
